import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { type CallHistory } from 'entities/CallHistory/model/CallHistory'

export class RowCallHistory extends RowBase<CallHistory> {
  constructor(origin: CallHistory) {
    super(origin)

    makeObservableRowBase(this)
  }

  get number() {
    return this.origin.number
  }

  get call() {
    return this.origin.call
  }

  get callDuration() {
    return this.origin.callDuration
  }

  get audioUrl() {
    return this.origin.audioUrl
  }

  get isUnread() {
    return this.origin.isUnread
  }

  get agentCallId() {
    return this.origin.agentCallId
  }

  get contacted_user() {
    return this.origin.contacted_user
  }

  get avatarInfo() {
    return this.origin.avatarInfo
  }

  get contactedUserName() {
    return this.origin.contactedUserName
  }

  get inbox() {
    return this.origin.inbox
  }

  get inboxName() {
    return this.origin.inboxName
  }

  get inboxNumber() {
    return this.origin.inboxNumber
  }
}
